import { makeRequest } from "./api";

export const FetchSpaces = async () => {
  return makeRequest("/api/admin/space/fetch");
};

export const CreateSpace = async (formData) => {
  return makeRequest("/api/admin/space/create", {
    method: "POST",
    data: formData,
    eaders: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateSpace = async (formData) => {
  return makeRequest("/api/admin/space/update", {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeleteSpace = async (spaceId) => {
  return makeRequest(`/api/admin/space/remove/${spaceId}`, {
    method: "DELETE",
  });
};
